import { useState, useCallback } from 'react';

export const useOccurrenceSelection = ({ onTabChange }) => {
    const [selectedOccurrence, setSelectedOccurrence] = useState(null);
    const [isFollowUp, setIsFollowUp] = useState(false);

    const isSummaryEnabled = selectedOccurrence !== null;

    const handleViewOccurrence = useCallback((incident, followUp = false) => {
        setSelectedOccurrence(incident);
        setIsFollowUp(followUp);
        onTabChange?.('summary');
    }, [onTabChange]);

    const handleClearSelection = useCallback(() => {
        setSelectedOccurrence(null);
        setIsFollowUp(false);
    }, []);

    return {
        selectedOccurrence,
        isFollowUp,
        isSummaryEnabled,
        handleViewOccurrence,
        handleClearSelection,
    };
};
